import {all, takeEvery, put, select, call} from "redux-saga/effects";
import {initialize} from "redux-form";
import UsersService from "../services/users";

function callUpdatePasswordUser(body) {
    return UsersService.changePassword(body);
}

function* handleInitForm() {
    const state = yield select();
    const editPasswordForm = {
        id: state.userLogin.userData.id,
        password: "",
        new_password: "",
        confirm_password: "",        
    }
    yield put(initialize('editPassword', editPasswordForm));
}

function* handleSavePassword(action) {
    yield call(callUpdatePasswordUser, action.payload);
}

export function* watchSecurityAndLoginActions() {
    yield all([
        takeEvery("INIT_PASSWORD_FORM", handleInitForm),
        takeEvery("SAVE_PASSWORD_DATA", handleSavePassword)
    ])
}
